import React, { useEffect, useRef, useState } from 'react';
import { Menu, LogOut, PencilLine } from 'lucide-react';
import './profileMenu.scss';

// دکمه‌ی منوی بالای صفحه‌ی پروفایل: «ویرایش پروفایل» و «خروج از حساب»
function ProfileMenu({ onLogout, onEdit }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const close = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener('mousedown', close);
    document.addEventListener('touchstart', close);
    return () => {
      document.removeEventListener('mousedown', close);
      document.removeEventListener('touchstart', close);
    };
  }, []);

  return (
    <div className="profile-menu" ref={ref}>
      <button type="button" className="profile-menu__btn" aria-label="منو" aria-expanded={open} onClick={() => setOpen((v) => !v)}>
        <Menu size={22} strokeWidth={1.8} />
      </button>
      {open && (
        <ul className="profile-menu__list" role="menu">
          {onEdit && (
            <li>
              <button
                type="button"
                role="menuitem"
                className="profile-menu__item"
                onClick={() => {
                  setOpen(false);
                  onEdit();
                }}
              >
                <PencilLine size={17} strokeWidth={1.8} />
                <span>ویرایش پروفایل</span>
              </button>
            </li>
          )}
          <li>
            <button
              type="button"
              role="menuitem"
              className="profile-menu__item is-danger"
              onClick={() => {
                setOpen(false);
                onLogout?.();
              }}
            >
              <LogOut size={17} strokeWidth={1.8} />
              <span>خروج از حساب</span>
            </button>
          </li>
        </ul>
      )}
    </div>
  );
}

export default ProfileMenu;
